export interface FlowMenuItem {
  id: number | string;
  parent_id: number | string | null;
  name: string;
  url?: string;
  enabled?: boolean;
  title?: string;
  childs?: FlowMenuItem[];
}

export function buildFlowTree(
  items: FlowMenuItem[],
  parentId: number | string | null = null
): FlowMenuItem[] {
  const result: FlowMenuItem[] = [];

  for (const item of items) {
    if (Number(item.parent_id) === Number(parentId)) {
      const newItem: FlowMenuItem = { ...item };

      newItem.childs = buildFlowTree(items, item.id);

      result.push(newItem);
    }
  }

  return result;
}
